import { C } from '../../theme.js';
import { FieldLabel } from '../../components/Primitives.jsx';
import { Segmented } from '../StepInspector.jsx';
import { ColSelect } from '../shared/ColSelect.jsx';

// ── Type & parse ───────────────────────────────────────────────────────
export function CastTypeInspector({ step, onChange }) {
  const c = step.config || {};
  const u = (patch) => onChange({ ...step, config: { ...c, ...patch } });
  return (
    <div>
      <FieldLabel>Column</FieldLabel>
      <ColSelect value={c.column} onChange={(v) => u({ column: v })} />
      <FieldLabel>Target type</FieldLabel>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6 }}>
        {[
          { id: 'string', label: 'String', desc: '"123"' },
          { id: 'integer', label: 'Integer', desc: '123' },
          { id: 'number', label: 'Float', desc: '123.45' },
          { id: 'boolean', label: 'Boolean', desc: 'true' },
          { id: 'datetime', label: 'Datetime', desc: '2026-05-23' },
        ].map(t => {
          const on = (c.target || 'string') === t.id;
          return (
            <button key={t.id} onClick={() => u({ target: t.id })}
              style={{
                fontFamily: 'inherit', cursor: 'pointer', textAlign: 'left',
                background: on ? 'var(--info-bg)' : C.input,
                color: on ? C.accentBright : C.fg3,
                border: `1px solid ${on ? C.accentMuted : C.border}`,
                borderRadius: 8, padding: '8px 10px',
                fontSize: '.78rem', fontWeight: 600,
              }}>
              <div>{t.label}</div>
              <div style={{ color: C.fg5, fontSize: '.7rem', marginTop: 2, fontFamily: "'JetBrains Mono', monospace" }}>{t.desc}</div>
            </button>
          );
        })}
      </div>
      <FieldLabel>On parse failure</FieldLabel>
      <Segmented
        value={c.onError || 'null'}
        onChange={(v) => u({ onError: v })}
        options={[
          { value: 'null', label: 'Set null' },
          { value: 'skip', label: 'Skip row' },
          { value: 'halt', label: 'Halt run' },
        ]}
      />
    </div>
  );
}
